import React, { useContext } from 'react';
import { GridWrapper, Button, Heading, Alert, Text, GridRow, GridColumn } from 'react-onei';

import TagService from '../../../services/TagService';
import UserContext from '../../../context/UserContext';
import { events } from '../../../conf/tags_ga.conf';

const PendingLetter = () => {
  const { serviceConf, wording } = useContext(UserContext);
  const { redirectUrl } = serviceConf;
  const { WBUTTON_003, WLOST_200, WLOST_250, WLOST_251 } = wording;

  function handleClick() {
    TagService.sendEvent(events.endLetter);
    window.location.href = redirectUrl;
  };

  return (
    <GridWrapper>

      <GridRow>
        <GridColumn>
          <Heading as="h3" id="pending-letter-subtitle" className="spacing-xs">{WLOST_200}</Heading>
        </GridColumn>
      </GridRow>

      <GridRow>
        <GridColumn size={{ xs: 1, m: 6 / 12 }}>
          <Alert id="pending-letter-alert" mini variant="alert" title={WLOST_250} />
          <Text
            id="pending-letter-message"
            variant="standard"
            className="spacing-xs"
          >
            {WLOST_251}
          </Text>
        </GridColumn>
      </GridRow>

      <GridRow>
        <GridColumn>
          <Button
            id="end-letter-button"
            onClick={handleClick}
            className="spacing-s"
          >
            {WBUTTON_003}
          </Button>
        </GridColumn>
      </GridRow>

    </GridWrapper>
  );
}

export default PendingLetter;